// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'processor';

export const Component = () => (
  <path d='M21.6 8.812h2.92v-.958H21.6V2.92h-4.934V0h-.957v2.921h-2.97V0h-.958v2.921h-2.97V0h-.957v2.921H2.92v4.933H0v.958h2.921v2.97H0v.957h2.921v2.97H0v.957h2.921V21.6h4.933v2.921h.958V21.6h2.97v2.92h.957V21.6h2.97v2.92h.957V21.6H21.6v-4.934h2.921v-.957H21.6v-2.97h2.92v-.958H21.6v-2.97Zm-1.007-4.885v16.667H3.927V3.927h16.666Z' />
);

export const viewBox = '0 0 25 25';
